import React from 'react'

// Style
import { makeStyles } from '@material-ui/core/styles'

// Loader
import SyncLoader from "react-spinners/SyncLoader"

const useStyles = makeStyles((theme) => ({
    loading: {
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
    },
}));

export default function Loader({ loading }) {

    const classes = useStyles()

    return (
    <div className={classes.loading}>
        <SyncLoader
            size={40}
            color={"#123abc"}
            loading={loading}
        />
    </div>
    )

}